module.exports = __webpack_public_path__ + "35c289c76a750494d91483327cf3aeac.svg";